"use strict";

// this is throwing a weird eslint error

// var ac = require('ve-api-check');
module.exports = function filterSequenceString(sequenceString) {
  var additionalValidChars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var charOverrides = arguments[2];

  // ac.throw(ac.string,sequenceString);
  if (sequenceString) {
    return sequenceString.replace(new RegExp("[^" + (charOverrides || "atgcyrswkmbvdhnu" + additionalValidChars.split("").join("\\")) + "]", "gi"), "");
  } else {
    return sequenceString;
  }
};